import React, { useState, useEffect } from "react";
import userContext  from "./userContext";
import config from "../../config";
import axios from 'axios';
const UserState = (props) =>{

    let state = {
        loggedIn: false,
        userId: null,
        token: null,
        profile: null
    };

    const [userState, updateUserState] = useState(state)
  
    const token = localStorage.getItem("token");

    const fetchUserLoggedIn = async()=>{
        console.log(token)
        if(token){
            let response = await axios.get(config.BACKEND.URL+"/user/auth/profile",{
                headers:{
                "x-api-key":"meritverse",
                "auth-token":token
                }  
            });
            console.log(response.data)
            if(response.data.success){
                console.log(response.data.result.user)
                updateUserState({
                    ...userState,
                    loggedIn:true,
                    profile:response.data.result.user,
                    token:token,
                    userId:response.data.result.user._id
                })

                localStorage.setItem("token", token)
                localStorage.setItem("userId", response.data.result.user._id)

            }
        }  
    }

    useEffect(()=>{
            fetchUserLoggedIn()
    },[])


    return(
        <userContext.Provider value={{userState, updateUserState}}>
            {props.children}
        </userContext.Provider>
    )
}


export default UserState;